
/* ===================================  007 Report  =================================== */
export const Reporter007 = {
    SLIDE_ENTERPRISE: 'slide-enterprise',
    SLIDE_V3: 'slide_v3',
    // 对应status上报类型的status，0: 成功；1：失败；2：超时；
    SUCCESS: 0,
    ERROR: 1,
    TIMEOUT: 2,
};

export const Reporter007ModuleType = {
    UPLOAD_IMAGE: 'upload_image',
};

export const Reporter007ActionType = {
    IMAGE_DETECT: `${Reporter007ModuleType.UPLOAD_IMAGE}/image_detect`,       // 上报 tiff/超大图片
    IMAGE_COMPRESS: `${Reporter007ModuleType.UPLOAD_IMAGE}/image_compress`,   // 图片压缩
    IMAGE_UPLOAD: `${Reporter007ModuleType.UPLOAD_IMAGE}/image_upload`,       // 图片上传
    IMAGE_GET_DIMENSIONS: `${Reporter007ModuleType.UPLOAD_IMAGE}/image_get_dimensions`,   // 图片尺寸计算
    IMAGE_GIF_FRAME_UPLOAD: `${Reporter007ModuleType.UPLOAD_IMAGE}/image_gif_frame_upload`,   // gif 首帧图上传
    SLIDE_JS_ERROR: 'slide-jsError',  // js error上报
    SLIDE_PV: 'slide-pv',  // 所有端pv上报
    SLIDE_PV_PC: 'slide-pv-pc',  // pc端pv上报
    SLIDE_PV_MOBILE: 'slide-pv-mobile',  // 移动端pv上报
    SLIDE_PV_ENVID: 'slide-pv-envid',  // 排查envid问题
    // eslint-disable-next-line @tencent/i18next/no-literal-string
    WHITE_SCREEN: '白屏', // 白屏
    // eslint-disable-next-line @tencent/i18next/no-literal-string
    OPEN_DOC_FAILURE: '关键数据获取失败', // data?get接口失败
    // eslint-disable-next-line @tencent/i18next/no-literal-string
    TTI: '可编辑耗时', // 可编辑耗时
    // eslint-disable-next-line @tencent/i18next/no-literal-string
    TTI_SUCCEED_IN_5S: '5s打开成功率', // 5s打开成功率
    // eslint-disable-next-line @tencent/i18next/no-literal-string
    LIST_SUCCEED_IN_5S: '5s列表显示成功率', // 5s列表显示成功率
    // eslint-disable-next-line @tencent/i18next/no-literal-string
    LIST_SUCCEED_IN_10S: '10s列表显示成功率', // 10s列表显示成功率
    SOURCE1: 'source1',
    // eslint-disable-next-line @tencent/i18next/no-literal-string
    SLIDE_SHOW_COST: 'slide首现耗时',
    // eslint-disable-next-line @tencent/i18next/no-literal-string
    SLIDE_SHOW_IN_5: 'slide首现在5s内',
    SLIDE_TOGGLE: 'slide-toggle-status',  // slide灰度开关状态
    CHART_RENDER_STATUS: 'slide-chart-render-status',   // 灰度图表期间走真正图表渲染，全量后移除

    // Snapshot 相关
    KEYFRAME_NOT_EXIST: 'keyframe-not-exist',
    TRANSFORM_KEYFRAME_FAILED: 'sdk_get_keyframe_failed',
    EXPORT_DOC_BY_SNAPSHOT: 'export-doc-by-snapshot',

    // 基于快照生成副本
    CREATE_DOC_BY_SNAPSHOT: 'create-doc-by-snapshot',

    // 根据列表内可见slide数计算出的应保存的渲染树数量超限
    VISABLE_SLIDE_KEY_LIST_OVER_LIMIT: 'visable-slide-key-list-over-limit',
    // 右侧渲染树数量超限
    RIGHT_RENDER_TREE_OVER_LIMIT: 'right-render-tree-over-limit',
};
